<p class="sidebar-form-description">{{ entityName | translate }}</p>

<form autocomplete="off" [formGroup]="formGroup" (ngSubmit)="saveData()">
  <app-entity-unify-update
    *ngIf="formGroup"
    [entity]="entity"
    [formGroup]="formGroup"
    [code]="entityCode"
    [isDesktop]="true"
    [isShowIdentifier]="false"
    [isShowPhone]="true"
    [isShowEmail]="true"
    [isWithFooter]="isUpdateIncoterms"
    [isLCLForeign]="isLCLForeign"
    (formCleared)="isFormCleared = true"
    (areaClicked)="isFormCleared = false"
  >
    <ng-container entity-footer *ngIf="isUpdateIncoterms">
      <div class="container p-0">
        <span class="switch-incoterms-warning">
          {{ "LABELS.SWITCHED_INCOTERMS" | translate }}
        </span>

        <lcl-incoterms-items
          [incotermsControl]="incotermsControl"
          [currentShippingRole]="shippingRole"
          (changeIncotermsSource)="setIncoterms($event)"
        ></lcl-incoterms-items>
      </div>
    </ng-container>
  </app-entity-unify-update>

  <div class="sidebar-form-buttons">
    <button type="submit" class="btn btn-primary">{{ "BUTTON.SAVE" | translate }}</button>
  </div>
</form>

<missing-fields code="MENU.LCL" (decline)="saveData(false)"></missing-fields>
